import { actionChannel, take } from "@redux-saga/core/effects";
import { find } from "lodash";
import { Action } from "redux";
import { Buffer, buffers, Channel } from "redux-saga";
import { call, fork, put } from "redux-saga/effects";
import { messageBoardDataManager } from "~/EasyProjects/MessageBoard/MessageBoardDataManager";
import { MessageBoardViewModel, MessageModelWithAnnotation } from "~/EasyProjects/MessageBoard/MessageBoardViewModel";
import { MessageViewModel } from "~/EasyProjects/MessageBoard/MessageViewModel";
import { AddAnnotation, AnnotationInfo, DeleteAnnotation, saveAnnotation, UpdateAnnotation } from "../actions";
import { ActionTypes } from "../const/ActionTypes";

type MessageBoardSyncActions = AddAnnotation | UpdateAnnotation | DeleteAnnotation;

export type messageBoardSyncProps = {
    messageBoardVm: MessageBoardViewModel;
    dataManager: typeof messageBoardDataManager;
};

export const messageBoardSync = (messageBoardSync: messageBoardSyncProps) => {
    const { messageBoardVm, dataManager } = messageBoardSync;

    function* deleteAnnotation(action: DeleteAnnotation) {
        const messageVm = find(messageBoardVm.messages(), (messageVm: MessageViewModel) => {
            return messageVm.messageId === action.value.message.messageId;
        });

        messageBoardVm.deletePost(messageVm);
    }

    function* updateAnnotationAction(action: UpdateAnnotation) {
        const updateMessageData = {
            model: {
                messageId: action.value.message.messageId,
                text: action.value.data.text,
            },
        };

        dataManager.editMessage(updateMessageData, (response: any) => {
            const messageVm = find(messageBoardVm.messages(), (messageVm: MessageViewModel) => {
                return messageVm.messageId === action.value.message.messageId;
            });
            messageVm._mapFromServerModel(response.Model);
        });
    }

    function* addAnnotationAction(action: AddAnnotation): Iterator<any, any, any> {
        const messageData = {
            Message: action.value.data.text,
            ...messageBoardVm.ownerInfo.getInfo(),
        };

        const response = yield dataManager.postMessage(messageData).then(x => x);

        const annotationData: AnnotationInfo = {
            messageId: response.Model.MessageId,
            projectId: messageData.projectId,
            taskId: messageData.taskId,
            metadata: JSON.stringify(action.value.geometry),
            annotationItem: action.value,
            messageInfo: response.Model,
        };

        const callback = (AnnotationId: number, AttachmentId: number, File: any) => {
            if (messageBoardVm) {
                const message: MessageModelWithAnnotation = {
                    ...response.Model,
                    Annotation: {
                        AnnotationId,
                        MessageId: annotationData.messageInfo.MessageId,
                        ProjectId: annotationData.projectId,
                        TaskId: annotationData.taskId,
                        AttachmentId,
                        Metadata: annotationData.metadata,
                        UserId: response.Model.UserId,
                        File,
                    },
                };
                messageBoardVm.addMessage(message, true);
            }
        };

        yield put(saveAnnotation(annotationData, callback));
    }

    function* messageBoardSyncChannel() {
        const buffer: Buffer<Action> = buffers.expanding(1);
        const channel: Channel<any> = yield actionChannel(
            [ActionTypes.ADD_ANNOTATION, ActionTypes.UPDATE_ANNOTATION, ActionTypes.DELETE_ANNOTATION],
            buffer
        );

        try {
            while (true) {
                const action: MessageBoardSyncActions = yield take(channel);

                switch (action.type) {
                    case ActionTypes.ADD_ANNOTATION: {
                        yield call(addAnnotationAction, action);
                        break;
                    }
                    case ActionTypes.UPDATE_ANNOTATION: {
                        yield call(updateAnnotationAction, action);
                        break;
                    }
                    case ActionTypes.DELETE_ANNOTATION: {
                        yield call(deleteAnnotation, action);
                        break;
                    }
                }
            }
        } finally {
            channel.close();
        }
    }

    return function* () {
        yield fork(messageBoardSyncChannel);
    };
};
